import { ExpLayoutSettings } from "app/components/ExpLayout/settings";
import merge from "lodash/merge";
import PropTypes from 'prop-types';
import { createContext, useCallback, useMemo, useState } from "react";

const SettingsContext = createContext({
	updateSettings: () => { },
	settings: ExpLayoutSettings
});

export const SettingsProvider = ({ settings, children }) => {
	const [currentSettings, setCurrentSettings] = useState(settings || ExpLayoutSettings);

	const handleUpdateSettings = useCallback((update = {}) => {
		setCurrentSettings(prevSettings => merge({}, prevSettings, update));
	}, []);

	// Added(2024-09-02, bhhan)
	const contextValue = useMemo(() => ({
		settings: currentSettings,
		updateSettings: handleUpdateSettings
	}), [currentSettings, handleUpdateSettings]);

	return (
		<SettingsContext.Provider value={contextValue}>
			{children}
		</SettingsContext.Provider>
	);
};

// Added(2024-09-02, bhhan)
SettingsProvider.propTypes = {
	settings: PropTypes.object,
	children: PropTypes.node.isRequired
};

// Added(2024-09-02, bhhan)
SettingsProvider.defaultProps = {
	settings: ExpLayoutSettings
};

export default SettingsContext;